// Ne rien importer ici : la façade et TreesUtil le chargent tous deux (cycle).
// Voir docs/binary-trees/COOKBOOK.md §1.4.

export const ROW = Symbol('grality.tree.row');

// null si l'arbre n'a pas été modifié depuis le chargement.
export const OVERRIDES = Symbol('grality.tree.overrides');

export const NESTED = Symbol('grality.tree.nested');

// Partagé par tout le bloc ; undefined si l'objet n'est pas une vue colonnaire.
// Lire OVERRIDES avant COLUMNS, sinon on sert l'ancienne valeur d'un arbre modifié.
export const COLUMNS = Symbol('grality.tree.columns');
